/**
 * "3 Images / 2 Videos" — capitalized, plural-aware. Empty string for
 * `n <= 0` so consumers can `.filter(Boolean).join(' / ')` and skip
 * absent media types.
 */
export function postMediaCountLabel(
  count: number | undefined,
  type: 'image' | 'video',
): string {
  if (count == null || count <= 0) return '';
  const label = type.charAt(0).toUpperCase() + type.slice(1);
  return `${count} ${label}${count > 1 ? 's' : ''}`;
}
